export default __webpack_public_path__ + "static/media/psc-member.37c334fa.jpg";